import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class Dummy implements Plugin {
  constructor(private element: HTMLElement) {}

  init(): void {
    console.log("Dummy Plugin initialized", this.element);
  }
}

PluginRegistry.register("dummy", Dummy);
